import { faUser } from '@awesome.me/kit-5231b03bd6/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const NoPhotoAvatar = () => {
  return (
    <FontAwesomeIcon
      icon={faUser}
      data-testid="no-photo-avatar"
      className="h-10 w-10 align-middle text-neutral-60"
    />
  );
};
